import { ShieldAlert, Mail, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

/**
 * Full-screen state shown to users whose account (agency or client) has been
 * suspended. They can still sign in, but instead of the app they get this
 * screen with a way to contact the Focus team and sign out.
 */
export function SuspendedAccountScreen({ variant = "agency" }: { variant?: "agency" | "client" }) {
  const { signOut } = useAuth();

  return (
    <div className="min-h-dvh flex items-center justify-center bg-background px-6">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="mx-auto h-14 w-14 rounded-full bg-destructive/10 flex items-center justify-center">
          <ShieldAlert className="h-7 w-7 text-destructive" />
        </div>
        <div className="space-y-2">
          <h1 className="font-display text-2xl font-semibold tracking-tight text-foreground">
            Your account has been suspended
          </h1>
          <p className="text-muted-foreground text-sm leading-relaxed">
            {variant === "agency"
              ? "While suspended, your agency profile and talent are hidden from Focus and you cannot use the agency dashboard. If you believe this is a mistake, or you'd like the suspension lifted, get in touch and our team will review it with you."
              : "While suspended, you cannot send requests to agencies or use your Focus account. If you believe this is a mistake, or you'd like the suspension lifted, get in touch and our team will review it with you."}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button asChild>
            <a href="mailto:info@focuscasting.com">
              <Mail className="mr-2 h-4 w-4" />
              Contact Focus Casting
            </a>
          </Button>
          <Button variant="outline" onClick={() => signOut()}>
            <LogOut className="mr-2 h-4 w-4" />
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SuspendedAccountScreen;
